import { ScheduleLegends } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';

const CourseTypeLegends = () => {
  const { t } = useTranslation(TranslationsKeys.TEACHER_SCHEDULE);

  const legends = [
    { id: 1, name: t(`scheduleLegends.course`) },
    { id: 2, name: t(`scheduleLegends.assistantship`) },
    { id: 3, name: t(`scheduleLegends.lab`) },
    { id: 4, name: t(`scheduleLegends.field`) },
    { id: 5, name: t(`scheduleLegends.workshop`) },
    { id: 6, name: t(`scheduleLegends.practice`) },
    { id: 7, name: t(`scheduleLegends.thesis`) },
    { id: 8, name: t(`scheduleLegends.other`) },
  ];

  return <ScheduleLegends legends={legends} />;
};

export default CourseTypeLegends;
